module.exports = __webpack_public_path__ + "img/Taiwan-2-hover.07dd90c6.jpg";